import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import IntroScreen from './components/intro-screen';
import ShuffleScreen from './components/shuffle-screen';
import AgeGateScreen from './components/age-gate-screen';
import AdultsOnlyScreen from './components/adults-only-screen';

const SCREEN = {
  AGE_GATE: 0,
  INTRO: 1,
  SHUFFLE: 2,
  ADULTS_ONLY: 3
};

const buildStorageKey = (explicitKey) => {
  if (explicitKey) return explicitKey;
  const campaign = sessionStorage.getItem('utm_campaign') || 'default';
  return `tarotFlowCompleted_${campaign}`;
};

const TarotFlowWrapper = ({
  children,
  enabled = true,
  storageKey = null,
  onComplete = null
}) => {
  const completionKey = buildStorageKey(storageKey);

  const [flowCompleted, setFlowCompleted] = useState(() => !enabled);
  const [screenNumber, setScreenNumber] = useState(SCREEN.AGE_GATE);

  const completeFlow = useCallback(() => {
    if (onComplete) onComplete();
    setFlowCompleted(true);
  }, [completionKey, onComplete]);

  if (flowCompleted) {
    return <>{children}</>;
  }

  const getScreen = () => {
    switch (screenNumber) {
      case SCREEN.ADULTS_ONLY:
        return <AdultsOnlyScreen />;
      case SCREEN.SHUFFLE:
        return <ShuffleScreen onComplete={completeFlow} />;
      case SCREEN.INTRO:
        return (
          <IntroScreen
            onStart={() => setScreenNumber(SCREEN.SHUFFLE)}
            onSkip={completeFlow}
          />
        );
      case SCREEN.AGE_GATE:
      default:
        return (
          <AgeGateScreen
            onConfirm={() => setScreenNumber(SCREEN.INTRO)}
            onDecline={() => setScreenNumber(SCREEN.ADULTS_ONLY)}
          />
        );
    }
  };

  return (
    <div
      className={styles.tarotFlow}
      style={screenNumber === SCREEN.SHUFFLE ? { overflow: 'hidden' } : {}}
    >
      {getScreen()}
    </div>
  );
};

export default TarotFlowWrapper;
